import './Loader.css';

const Loader = () => {
  return (
    <div className="loader-wrapper">
      <div className="loader">
        <svg height={0} width={0} viewBox="0 0 64 64" className="absolute">
          <defs xmlns="http://www.w3.org/2000/svg">
            <linearGradient gradientUnits="userSpaceOnUse" y2={2} x2={0} y1={62} x1={0} id="b">
              <stop stopColor="#973BED" />
              <stop stopColor="#007CFF" offset={1} />
            </linearGradient>
            <linearGradient gradientUnits="userSpaceOnUse" y2={0} x2={0} y1={64} x1={0} id="c">
              <stop stopColor="#FFC800" />
              <stop stopColor="#F0F" offset={1} />
              <animateTransform repeatCount="indefinite" keySplines=".42,0,.58,1;.42,0,.58,1;.42,0,.58,1;.42,0,.58,1;.42,0,.58,1;.42,0,.58,1;.42,0,.58,1;.42,0,.58,1" keyTimes="0; 0.125; 0.25; 0.375; 0.5; 0.625; 0.75; 0.875; 1" dur="8s" values="0 32 32;-270 32 32;-270 32 32;-540 32 32;-540 32 32;-810 32 32;-810 32 32;-1080 32 32;-1080 32 32" type="rotate" attributeName="gradientTransform" />
            </linearGradient>
            <linearGradient gradientUnits="userSpaceOnUse" y2={2} x2={0} y1={62} x1={0} id="d">
              <stop stopColor="#00E0ED" />
              <stop stopColor="#00DA72" offset={1} />
            </linearGradient>
          </defs>
        </svg>
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 700 170" height={85} width={350} className="inline-block">
          <g stroke="url(#c)" strokeWidth={10} strokeLinecap="round" strokeLinejoin="round" fill="none">
            <path className="dash" pathLength={360} d="M 20 130 L 20 40 L 50 90 L 80 40 L 80 130" />
            <path className="dash" pathLength={360} d="M 110 130 L 135 40 L 160 130 M 120 100 L 150 100" />
            <path className="dash" pathLength={360} d="M 190 40 L 240 130 M 240 40 L 190 130" />
            <path className="dash" pathLength={360} d="M 315 40 L 280 40 L 280 130 L 315 130" />
            <path className="dash" pathLength={360} d="M 385 85 m 0 -40 a 40 40 0 1 1 0 80 a 40 40 0 1 1 0 -80" />
            <path className="dash" pathLength={360} d="M 455 130 L 455 40 L 505 130 L 505 40" />
            <path className="dash" pathLength={360} d="M 585 40 L 540 40 L 540 85 L 585 85 L 585 130 L 540 130" />
            <path className="dash" pathLength={360} d="M 615 40 L 665 40 M 640 40 L 640 130" />
          </g>
        </svg>
      </div>
    </div>
  );
}

export default Loader;
